import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {

  getVersaoUpload () {
    return axios({
      method: 'get',
      url: `${modulo.PUBLICO}/versaoUpload`
    })
  },

  async gerarComprovante ({ commit }, protocolo) {
    await axios({
      method: 'get',
      url: `publico/cadastro/comprovante/${protocolo}`,
      responseType: 'blob'
    })
  },

  createByFilekey ({ commit }, fileKey) {
    return axios({
      method: 'post',
      url: `publico/create/${fileKey}`,
      timeout: 900000,
      loader: true,
      error: true
    })
  },

  createCadastroByFilekey ({ commit }, fileKey) {
    return axios({
      method: 'post',
      url: `publico/uploadcadastro/create/${fileKey}`,
      timeout: 900000,
      loader: true,
      error: true
    })
  },

  async salvarImportacao ({ commit }, data) {
    return axios({
      method: 'POST',
      url: `publico/cadastro/salvar`,
      data
    })
  },

  async getCadastrosAntigos ({ commit }, fileKey) {
    return axios({
      method: 'get',
      url: `publico/cadastro/buscarTodos`
    })
  },

  async exportarOff ({ commit }, fileKey) {
    return axios({
      method: 'get',
      url: `publico/importoff`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/upload.js